import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  roles: [],
  selectedRole: null,
};

const roleSlice = createSlice({
  name: "companyRoles",
  initialState,
  reducers: {
    // Get Roles
    getRolesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getRolesSuccess: (state, action) => {
      state.loading = false;
      state.roles = action.payload;
      state.error = null;
    },
    getRolesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Role
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },

    // Assign Role to User
    assignRoleStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    assignRoleSuccess: (state, action) => {
      state.loading = false;
      state.error = null;

      const roleId = Number(action.payload);

      state.roles = state.roles.map((role) => {
        if (Number(role.id) === roleId) {
          return {
            ...role,
            is_role_taken: 1,
          };
        }

        return role;
      });
    },
    assignRoleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getRolesStart,
  getRolesSuccess,
  getRolesFailure,
  assignRoleStart,
  assignRoleSuccess,
  assignRoleFailure,
  setSelectedRole,
  clearError,
} = roleSlice.actions;

export default roleSlice.reducer;
